import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Projects from '../components/projects';
import HeroImg5 from '../components/HeroImg5';


const Project = () => {
  return (
    <div>
      <Navbar />
      <HeroImg5 />
      <Projects />
      <Footer />

    </div>
  )
}

export default Project